import { useNavigate } from "react-router-dom";
import { ENABLE_USER_BULK } from "../../apiEndpoints";
import usePostData from "../../../../CustomHooks/useAxios/usePostData";
import Modal from "../../../../components/portal/Modal";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";

function MultiUserEnableDialog({ userIDs, closeDialog, selectedCount }) {
  const { executePost, loading, successResponse, formError, setFormError } =
    usePostData();

  const navigate = useNavigate();

  // Disable user API call
  const handleDisableUser = () => {
    const userIDsData = { user_id_list: userIDs };
    executePost(userIDsData, ENABLE_USER_BULK, () => {});
  };

  const getDisableMessage =
    selectedCount > 1
      ? `Are you sure you want to Enable ${selectedCount} users?`
      : "Are you sure you want to Enable this user?";

  const getSuccessMessage =
    selectedCount > 1
      ? `${selectedCount} users successfully enabled.`
      : "User successfully Enabled.";

  return (
    <>
      <Modal
        onClose={loading || successResponse ? undefined : closeDialog}
        modalWidth={`${
          successResponse ? "max-w-sm" : "max-w-lg"
        } w-11/12 max-sm:w-[95%] max-md:p-4 pb-8 pt-7 px-8`}
      >
        <>
          {successResponse ? (
            <div className="text-center">
              <img
                src={successIcon}
                alt="success"
                className="mx-auto w-9 mb-2"
              />
              <p className="py-5">{getSuccessMessage}</p>
              <GradientButton
                btnText="Ok"
                width="w-26"
                onClick={() => navigate("/user/all")}
              />
            </div>
          ) : (
            <>
              {formError && (
                <ErrorDisplay
                  message={formError}
                  closeAction={() => setFormError("")}
                />
              )}
              <h2 className="text-xl font-figtreeBold mb-4">
                {selectedCount > 1 ? "Enable Users" : "Enable User"}
              </h2>
              <p className="text-gray-700 mb-6">
                {getDisableMessage}
                <br />
                This action will allow
                {selectedCount === 1 ? "this user" : "these users"} from to log
                in and access their assigned modules.
              </p>
              {/* Buttons */}
              <div className="flex justify-end gap-3">
                <button
                  onClick={closeDialog}
                  className="px-4 py-2 rounded-lg border bg-dBlue-100 hover:bg-gray-200 text-dark-blue"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDisableUser}
                  className="px-4 py-2 rounded-lg bg-teal-600 hover:bg-teal-500 text-white"
                  disabled={loading}
                >
                  {loading ? "Enabling..." : "Enable"}
                </button>
              </div>
            </>
          )}
        </>
      </Modal>
    </>
  );
}

export default MultiUserEnableDialog;
